import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { ITermCourse } from '../../../main';

export interface ICourseAlerts {
  course: ITermCourse | undefined;
  hasDevReq?: boolean;
  hasMissingReqs?: boolean;
}

export type CourseAlertsModel = ITypedModel<ICourseAlerts>;

angular.module('capability-ng-scheduler').factory(
  'ngCourseAlertsModel',
  (): CourseAlertsModel =>
    new Model<ICourseAlerts>({
      course: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/course_alerts/models/course_alerts_model.ts